/*
包含n个接口请求函数的模块  返回promise对象
 */
import ajax from './ajax';
import { reqExpost } from './ajax';
import { url } from './url';
export const BASE_URL = url;


export const selectRepaymentDetailPage = (params) =>ajax(`${BASE_URL}
/factory/studio/selectRepaymentDetailPage`,params,"GET");
export const selectOverdrawPage = (params) =>ajax(`${BASE_URL}
/factory/studio/selectOverdrawPage`,params,"GET");
export const selectUnRepaymentAmountByBillDate = (params) =>ajax(`${BASE_URL}
/factory/studio/selectUnRepaymentAmountByBillDate`,params,"GET");
export const addRepaymentDetail = (params) =>ajax(`${BASE_URL}
/factory/studio/addRepaymentDetail`,params,"POST");
export const modifyFinanceByUser = (params) =>ajax(`${BASE_URL}
/factory/finance/modifyFinanceByUser`,params,"POST");
export const selectUserList = (params) =>ajax(`${BASE_URL}
/factory/user/selectUserList`,params,"GET");
export const doPrintSubExpress = (expressId,quantity,params) =>ajax(`${BASE_URL}
/factory/orderExpress/doPrintSubExpress/${expressId}/${quantity}`,params,"GET");
export const getOrderLabel = (params) =>ajax(`${BASE_URL}
/factory/order/getOrderLabel`,params,"GET");
export const deletekdDevice = (id) =>ajax(`${BASE_URL}
/factory/system/kdDevice/delete/${id}`,{},"GET");

export const exportOrderExpress = (params) =>reqExpost("POST",`${BASE_URL}
/factory/orderExpress/exportOrderExpress`,params);
export const selectStorehouseStatistical = (params) =>ajax(`${BASE_URL}
/factory/system/storehouse/no/selectStorehouseStatistical`,params,"GET");
export const changetaskStatus = (params) =>ajax(`${BASE_URL}
/factory/system/task/changeStatus`,params,"GET");
export const removetask = (taskId) =>ajax(`${BASE_URL}
/factory/system/task//remove/${taskId}`,{},"GET");
export const saveOrUpdatetask = (params) =>ajax(`${BASE_URL}
/factory/system/task/saveOrUpdate`,params,"POST");
export const selectTaskPage = (params) =>ajax(`${BASE_URL}
/factory/system/task/selectTaskPage`,params,"GET");

export const deleteOrderDetailExpress = (orderDetailExpressId) =>ajax(`${BASE_URL}
/factory/orderExpress/deleteOrderDetailExpress/${orderDetailExpressId}`,{},"GET");
export const doRepeatPrintExpress = (expressId,params) =>ajax(`${BASE_URL}
/factory/orderExpress/doRepeatPrintExpress/${expressId}`,params,"GET");

export const exportUserFinance = (params) =>reqExpost("POST",`${BASE_URL}
/factory/finance/exportUserFinance`,params);

export const exportFinance = (params) =>reqExpost("POST",`${BASE_URL}
factory/finance/exportFinance`,params);
export const clickFinish = (params) =>ajax(`${BASE_URL}
/factory/process/clickFinish`,params,"POST");
export const financeReworkList = (params) =>ajax(`${BASE_URL}
/factory/finance/financeReworkList`,params,"GET");
export const getListByOrderId = (params) =>ajax(`${BASE_URL}
/factory/process/getListByOrderId`,params,"GET");
export const storehousegetList = () =>ajax(`${BASE_URL}
/factory/system/storehouse/no/getList`,{},"GET");
export const insertSet = (params) =>ajax(`${BASE_URL}
/factory/system/storehouse/no/insertSet`,params,"POST");
export const selectOrderDetailExpressByExpressId = (expressId) =>ajax(`${BASE_URL}
/factory/orderExpress/selectOrderDetailExpressByExpressId/${expressId}`,{},"GET");
export const selectExpressSummaryPage = (params) =>ajax(`${BASE_URL}
/factory/orderExpress/selectExpressSummaryPage`,params,"GET");
export const selectExpressSummary = () =>ajax(`${BASE_URL}
/factory/orderExpress/selectExpressSummary`,{},"GET");
export const selectFactoryExpenseDetailPageorderDetailId = (orderDetailId) =>ajax(`${BASE_URL}
/factory/orderDetail/selectProgressByShareOrderDetailId/${orderDetailId}`,{},"GET");

export const selectFactoryExpenseDetailPage = (params) =>ajax(`${BASE_URL}
/factory/expenseDetail/selectFactoryExpenseDetailPage`,params,"GET");
export const getByTradeNo = (params) =>ajax(`${BASE_URL}
/factory/chargeDetail/getByTradeNo`,params,"GET");
export const selectFactoryChargeDetailPage = (params) =>ajax(`${BASE_URL}
/factory/chargeDetail/selectFactoryChargeDetailPage`,params,"GET");
export const wxorder = (params) =>ajax(`${BASE_URL}
/factory/third/pay/wx/charge`,params,"POST");
export const alipaycharge = (params) =>ajax(`${BASE_URL}
/factory/third/pay/alipay/charge`,params,"POST");
export const delUserRole = (userId,roleId) =>ajax(`${BASE_URL}
/factory/user/delUserRole/${userId}/${roleId}`,{},'GET');
export const batchRemoveSkuSharepoolUse = (params) =>ajax(`${BASE_URL}
/factory/product/productSkuSharepool/batchRemoveSkuSharepoolUse`,params);
export const getSKUInfoById = (skuId) =>ajax(`${BASE_URL}
/factory/product//sku/getSKUInfoById/${skuId}`,{});
export const selectOrderByCode = (params) =>ajax(`${BASE_URL}
/factory/order/selectOrderByCode`,params,"GET");
export const deleteStudioAuditNotify = (params) =>ajax(`${BASE_URL}
/factory/studio/deleteStudioAuditNotify`,{},"GET");
export const updateStudioAuditNotify = (params) =>ajax(`${BASE_URL}
/factory/studio/updateStudioAuditNotify`,{},"POST");
export const getStudioAuditNotify = (params) =>ajax(`${BASE_URL}
/factory/studio/getStudioAuditNotify`,{},"GET");
export const selectUnCheckedSkuSharePage = (params) =>ajax(`${BASE_URL}
/factory/product/productSkuSharepool/selectUnCheckedSkuSharePage`,params,"GET");

export const selectAgentFactoryPage = (params) =>ajax(`${BASE_URL}
/factory/selectAgentFactoryPage`,params,"GET");
export const selectFactoryAccountDetailPage = (params) =>ajax(`${BASE_URL}
/factory/accountDetail/selectFactoryAccountDetailPage`,params,"GET");
export const doFactoryAccountPayment = (params) =>ajax(`${BASE_URL}
/factory/accountDetail/doFactoryAccountPayment`,params,"POST");
export const doFactoryAccountCharge = (params) =>ajax(`${BASE_URL}
/factory/accountDetail/doFactoryAccountCharge`,params,"POST");
export const selectAgentFactoryDetail = (params) =>ajax(`${BASE_URL}
/factory/selectAgentFactoryDetail`,params,"GET");
export const selectPlatformSkuPage = (params) =>ajax(`${BASE_URL}
/factory/product/productSkuSharepool/selectPlatformSkuPage`,params,"GET");
export const selectPlatformFactoryPage = (params) =>ajax(`${BASE_URL}
/factory/selectPlatformFactoryPage`,params,"GET");
export const userDeductionexportUserDeduction = (params) => reqExpost('POST',`${BASE_URL}
/factory/userDeduction/exportUserDeduction`,params);
export const selectOrderExpressStatisticsTops = (params) =>ajax(`${BASE_URL}
/factory/orderExpressStatistics/selectOrderExpressStatisticsTops`,params,"GET");
export const selectOrderExpressStatisticsPage = (params) =>ajax(`${BASE_URL}
/factory/orderExpressStatistics/selectOrderExpressStatisticsPage`,params,"GET");
export const tabStatisdelete = (id) =>ajax(`${BASE_URL}
/factory/tabStatis/delete/${id}`,{},"GET");
export const statisticsadd = (params) =>ajax(`${BASE_URL}
/factory/finance/statistic/home/sku/statistics/add`,params,"POST");
export const getNowProduction = (params) =>ajax(`${BASE_URL}
/factory/process/getNowProduction`,params,"GET");
export const nameindex = (params) =>ajax(`${BASE_URL}
/factory/product/sku/name/index`,params,"GET");
export const selectFactoryList = (params) =>ajax(`${BASE_URL}
/factory/selectFactoryList`,params,"POST");
export const monitorindex = (params) =>ajax(`${BASE_URL}
/factory/monitor/index`,params,"POST");
export const selectOrderMonitorIndexCount = (params) =>ajax(`${BASE_URL}
/factory/orderDetail/selectOrderMonitorIndexCount`,params);
export const selectDeliveryOrderPage = (params) =>ajax(`${BASE_URL}
/factory/order/selectDeliveryOrderPage`,params);
export const tabStatisgetDetail = (params) =>ajax(`${BASE_URL}
/factory/tabStatis/getDetail`,params);
export const tabStatisgetList = (params) =>ajax(`${BASE_URL}
/factory/tabStatis/getList`,params);
export const saveOrUpdateTabStatis = (params) =>ajax(`${BASE_URL}
/factory/tabStatis/saveOrUpdateTabStatis`,params,"POST");
export const statisticslist = (params) =>ajax(`${BASE_URL}
/factory/finance/statistic/home/sku/statistics/list`,params);
export const bindingcategory = (params) =>ajax(`${BASE_URL}
/factory/finance/statistic/home/binding/category`,params);
export const updateUserPwd = (params) =>ajax(`${BASE_URL}
/factory/user/updateUserPwd`,params,'POST');
///factory/menu/getUserMenu/{userId}
export const deleteuserDeduction = (id) =>ajax(`${BASE_URL}
/factory/userDeduction/delete/${id}`,{});

export const saveOrUpdateUserDeduction = (params) =>ajax(`${BASE_URL}
/factory/userDeduction/saveOrUpdateUserDeduction`,params,'POST');
export const exportOrderFeedbackInfo = (params) => reqExpost('POST',`${BASE_URL}
/factory/order/feedBack/exportOrderFeedbackInfo`,params);
export const importStudioCoupon =`${BASE_URL}/factory/coupon/importStudioCoupon`;
export const importStudioCoupon2 =`${BASE_URL}/factory/coupon/importStudioCarriageCoupon`;
export const exportReworkInfo = (params) => reqExpost('POST',`${BASE_URL}
/factory/process/exportReworkInfo`,params);
export const productNonStandardgetById = (id) => ajax(`${BASE_URL}
/factory/product/productNonStandard/getById/${id}`);

export const selectKdDevicePage = (params) => ajax(`${BASE_URL}
/factory/system/kdDevice/selectKdDevicePage`, params);
export const kdDeviceinsertOrUpdate = (params) => ajax(`${BASE_URL}
/factory/system/kdDevice/insertOrUpdate`, params,'POST');
export const deleteProductSkuSharepoolUse = (id) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/deleteProductSkuSharepoolUse/${id}`, {});
export const deleteProductSkuSharepool = (params) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/deleteProductSkuSharepool`, params);
export const selectSkuSharepoolAuthPage = (params) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/selectSkuSharepoolAuthPage`, params);
export const saveProductSkuSharepool = (params) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/saveProductSkuSharepool`, params,'POST');
export const getPlatformSkuCategoryTree = (params) => ajax(`${BASE_URL}
factory/system/platformSkuCategory/getPlatformSkuCategoryTree`, {});
export const saveOrUpdateProductSkuSharepoolUse = (params) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/saveOrUpdateProductSkuSharepoolUse`, params,'POST');
export const findKdTraceQuery = (params) => ajax(`${BASE_URL}
/factory/order/findKdTraceQuery`, params,'POST');
export const selectUnUseProductSkuSharepoolPage = (params) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/selectUnUseProductSkuSharepoolPage`, params,'POST');
export const selectFactorySkuSharepoolUse = (params) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/selectFactorySkuSharepoolUse`, params,'GET');
export const actualMoney = (params) => ajax(`${BASE_URL}
/factory/system/freight/template/actual/money`, params);
export const selectPublishSkuSharePoolPage = (params) => ajax(`${BASE_URL}
/factory/product/productSkuSharepool/selectPublishSkuSharePoolPage`, params);
export const arealist = (id) => ajax(`${BASE_URL}/factory/system/studio/config/area/list`, {areaId:id});
export const areaBind = (params) => ajax(`${BASE_URL}/factory/system/studio/config/area/bind`, params,'POST');
export const selectOrderDetail = () => ajax(`${BASE_URL}/factory/indexStatistical/selectOrderDetailProcedureStatistical`, {},'POST');
export const getUserMenu = userId => ajax(`${BASE_URL}factory/menu/getUserMenu/${userId}`,{});
export const selectFeedBackIndexCount = params => ajax(`${BASE_URL}factory/order/feedBack/selectFeedBackIndexCount`, params,"POST");

export const exportOrderDetailInfo = params => reqExpost('POST', `${BASE_URL}factory/orderDetail/exportOrderDetailInfo`, params);
export const productionConsume = params => reqExpost('POST',`${BASE_URL}factory/inventory/export/production/consume`, params);


export const getProductionIn = params => ajax(`${BASE_URL}factory/process/getProductionIn`, params);
export const getWorkDayInfo = params => ajax(`${BASE_URL}factory/process/getWorkDayInfo`, params);
export const findeQueuePage = params => ajax(`${BASE_URL}factory/queue/findeQueuePage`, params,'POST');
export const goProcess = params => ajax(`${BASE_URL}factory/process/goProcess`, params,'POST');
export const freightmoney = params => ajax(`${BASE_URL}factory/system/freight/template/money`, params);
//标品下单选择产品后请求

export const addCartItem = params => ajax(`${BASE_URL}factory/order/task/addCartItem`, params,"POST");
// 配货重新生成
export const addNonStandardCustomer = params => ajax(`${BASE_URL}factory/order/task/addNonStandardCustomer`, params,"POST");

export const addNonStandardCartItem = params => ajax(`${BASE_URL}factory/order/task/addNonStandardCartItem`, params,"POST");
export const selectInProcess = params => ajax(`${BASE_URL}factory/order/selectInProcess`, params);
export const reworkHandle = params => ajax(`${BASE_URL}factory/process/reworkHandle`, params, 'POST');
export const rebuild = params => ajax(`${BASE_URL}factory/inventory/production/distribution/rebuild`, params, 'POST');
export const orderjj = params => ajax(`${BASE_URL}factory/order/updateOrder`, params, 'POST');
// 获取已调色列表
export const getFinishColor = query => ajax(`${BASE_URL}factory/tspb/getFinishColor`, query);
// 获取订单明细

export const getdeduction = params => ajax(`${BASE_URL}factory/orderPay/deduction`, params, 'POST');
// 修改加急状态
export const updateOrderDetail = params => ajax(`${BASE_URL}factory/order/updateOrderDetail`, params, 'POST');
// 订单导出
export const exportKQ = params => reqExpost('POST', `${BASE_URL}factory/coupon/exportCouponStatistics`, params);
// 订单导出
export const exportStudioOrder = params => reqExpost('POST', `${BASE_URL}factory/studio/exportStudioOrder`, params);
// 导出充值记录
export const orderProfitExport = params => reqExpost('POST', `${BASE_URL}factory/studio/exportStudioAdvanceDetail`, params);
// 一键完工factory/tspb/finishColor
export const finishColor = params => ajax(`${BASE_URL}factory/tspb/finishColor`, params, 'POST');
// 一键开工
export const startColor = params => ajax(`${BASE_URL}factory/tspb/startColor`, params, 'POST');
export const getOnColorDetailIsIN = query => ajax(`${BASE_URL}factory/tspb/getOnColorDetail`, query);
// 调色获取列表
export const getOnColorDetail = query => ajax(`${BASE_URL}factory/tspb/getOnColorDetail`, query);
// 更新订单信息
export const updateOrder = params => ajax(`${BASE_URL}factory/order/updateOrder`, params, 'POST');
// 卡卷设置时间
export const updateCoupon = params => ajax(`${BASE_URL}factory/coupon/updateCoupon`, params, 'POST');

// 根据ID获取客户信息
export const getCustomerInfo = params => ajax(`${BASE_URL}factory/studio/findStudioInfoById`, params, 'POST');

// 开工回退

export const productionBack = params => ajax(`${BASE_URL}factory/tspb/productionBack`, params, 'POST');
// 删除快递单
export const deleteOrderExpress = id => ajax(`${BASE_URL}factory/order/deleteOrderExpress`, id, 'POST');

// 获取角色权限
export const getRoleQX = roleId => ajax(`${BASE_URL}factory/menu/tree/${roleId}`, {}, 'POST');
// 手动出标签
export const newgetLabelInfo = (code, type) => ajax(`${BASE_URL}factory/process/getLabelInfo?code=${code}&type=${type}`);



export const getLabelInfo = code => ajax(`${BASE_URL}factory/process/getLabelInfo?code=${code}`);
// 删除权限模块 factory/menu/remove
export const removeMenu = params => ajax(`${BASE_URL}factory/menu/remove`, params, 'POST');
// 更新权限设置
export const updateMenu = params => ajax(`${BASE_URL}factory/menu/update`, params, 'POST');
// 保存角色权限
export const saveRoleMenu = params => ajax(`${BASE_URL}factory/role/update`, params, 'POST');
// 获取模块
export const getMenu = params => ajax(`${BASE_URL}factory/menu/tree`, {}, 'POST');

// 新增模块
export const saveMenu = params => ajax(`${BASE_URL}factory/menu/save`, params, 'POST');

// 删除角色
export const deleteUserRole = id => ajax(`${BASE_URL}factory/role/remove/${id}`, {}, 'POST');
// 更新角色
export const updateUserRole = params => ajax(`${BASE_URL}factory/role/update`, params, 'POST');
// 查看角色
export const getUserRole = params => ajax(`${BASE_URL}factory/role/findRoleByPage`, params, 'POST');
//
export const getlistProcedureByUser = (userId, statTime, endTime) => ajax(`${BASE_URL}factory/finance/listProcedureByUser?userId=${userId}&statTime=${statTime}&endTime=${endTime}`);
// 新增角色
export const addUserRole = params => ajax(`${BASE_URL}factory/role/save`, params, 'POST');
// 获取产品耗材
export const getProductconsumables = (code) => ajax(`${BASE_URL}factory/inventory/sku/${code}`);
// 获取工序详情
export const getprocedureInfo = (code) => ajax(`${BASE_URL}factory/system/procedure/index/code/${code}`);
// 查询平台信息
export const reqGetPlatformInfo = () => ajax(`${BASE_URL}factory/index`);
// 更新平台信息
export const reqUpdatePlatformInfo = (name, description, keywords, logo, email, hotline, slogan, address) => ajax(`${BASE_URL}factory/update`, { name, description, keywords, logo, email, hotline, slogan, address }, 'POST');
// 获取生产工序
export const reqGetProcedureList = () => ajax(`${BASE_URL}factory/system/procedure/list`);
// 删除工序
export const reqDelProcess = (id) => ajax(`${BASE_URL}factory/system/procedure/delete/${id}`, {}, 'params');
// 编辑工序名称
export const reqEditProcess = params => ajax(`${BASE_URL}factory/system/procedure/edit`, params, 'POST');
// 添加生产工序
export const reqAddProcess = params => ajax(`${BASE_URL}factory/system/procedure/add`, params, 'POST');
// 拖动工序排序
export const reqSortProcess = (procedureIdList) => ajax(`${BASE_URL}factory/system/procedure/sort`, { procedureIdList }, 'POST');

// 获取代理
export const reqAddAgency = () => ajax(`${BASE_URL}factory/system/agent/level/list`);
// 新增一级代理
export const reqAddOneAgency = (name) => ajax(`${BASE_URL}factory/system/agent/level/save`, { name }, 'POST');
// 新增二级代理
export const reqAddTwoAgency = (parentId, name) => ajax(`${BASE_URL}factory/system/agent/level/save`, { parentId, name }, 'POST');
// 编辑代理
export const reqUpdateOneAgency = (id, name) => ajax(`${BASE_URL}factory/system/agent/level/save`, { id, name }, 'POST');
// 删除代理
export const reqDelAgency = (id) => ajax(`${BASE_URL}factory/system/agent/level/delete/${id}`, {}, '');
// 获取平台统一调价
export const reqGetChangePrice = () => ajax(`${BASE_URL}factory/system/price/index`);
// 平台调价修改
export const reqResetChangePrice = (baseOperation, baseValue, baseUnit, vipValue, vipDesc) => ajax(`${BASE_URL}factory/system/price/save`, { baseOperation, baseValue, baseUnit, vipValue, vipDesc }, 'POST');
// 客户充值设置
export const reqRecharge = () => ajax(`${BASE_URL}factory/system/recharge/index`);
// 会员充值设置
export const reqRechargeSave = (vipValid, vipInvalid) => ajax(`${BASE_URL}factory/system/recharge/save`, { vipValid, vipInvalid }, 'POST');
// 获取返工原因
export const reqGetRework = (params) => ajax(`${BASE_URL}factory/system/rework/reason/list`,params)
//未完成任务检测
export const findStudioCartExist = params => ajax(`${BASE_URL}factory/order/task/findStudioCartExist`, params, 'POST')
//新增运费券信息
export const addCarriageCoupon = params => ajax(`${BASE_URL}factory/coupon/insertCarriageCoupon`,params,'POST' )
//编辑运费券信息
export const editCarriageCoupon = params => ajax(`${BASE_URL}factory/coupon/updateCoupon`,params,'POST')
//删除运费券信息
export const deleteCarriageCoupon = (couponId) => ajax(`${BASE_URL}factory/coupon/deleteCoupon`,{couponId},'POST')


// 新增返工原因
export const reqAddRework = (params) => ajax(`${BASE_URL}factory/system/rework/reason/save`, params, 'POST');
// 修改返工原因
export const reqUpdateRework = (params) => ajax(`${BASE_URL}factory/system/rework/reason/save`,params , 'POST');
// 返工下单参数
export const getParamsInfo = params => ajax(`${BASE_URL}factory/process/getParamsInfo`, params, 'POST');
// 删除返工原因
export const reqDelRework = (id) => ajax(`${BASE_URL}factory/system/rework/reason/delete/${id}`, {}, 'POST');
// 获取装订方式列表
export const reqGetBinding = params => ajax(`${BASE_URL}factory/system/binding/list`, params);
// 获取分类列表
export const reqGetCategoryList = () => ajax(`${BASE_URL}factory/system/binding/category/list`);
// 新增/编辑分类
export const reqAddCategory = params => ajax(`${BASE_URL}factory/system/binding/category/save`, params, 'POST');
// 删除分类
export const reqDelCategory = (id) => ajax(`${BASE_URL}factory/system/binding/category/delete/${id}`, {}, 'POST');
// 编辑装订方式
export const reqEditBinding = (id, name, categoryId) => ajax(`${BASE_URL}factory/system/binding/edit`, { id, name, categoryId }, 'POST');
// 新增装订方式
export const reqAddBinding = params => ajax(`${BASE_URL}factory/system/binding/add`, params, 'POST');
// 删除装订方式
export const reqDelBinding = (id) => ajax(`${BASE_URL}factory/system/binding/delete/${id}`, {}, 'POST');
// 关联装订方式列表获取
export const reqGetAssociationBinding = (id) => ajax(`${BASE_URL}factory/system/binding/list/procedure`, { id });
// 关联装订方式
export const reqAssociationBinding = (id, procedures, deliver, invalidNo, bindingGroup,syncToSKU,isBasics) => ajax(`${BASE_URL}factory/system/binding/add/procedure`, { id, procedures, deliver, invalidNo, bindingGroup ,syncToSKU,isBasics}, 'POST');
// 分类或生产线拖动排序
export const reqSortBinding = (type, idList) => ajax(`${BASE_URL}factory/system/binding/sort`, { type, idList }, 'POST');

// 获取排版方式列表
export const reqGetLayoutList = () => ajax(`${BASE_URL}factory/system/makeup/list`);
// 新增排版方式
export const reqAddLayout = (name) => ajax(`${BASE_URL}factory/system/makeup/save`, { name }, 'POST');
// 编辑排版方式
export const reqEditLayout = (id, name) => ajax(`${BASE_URL}factory/system/makeup/save`, { id, name }, 'POST');
// 删除排版方式
export const reqDelLayout = (id) => ajax(`${BASE_URL}factory/system/makeup/delete/${id}`, {}, 'POST');
// 根据客户类型 获取客户列表
export const reqGetClientList = (type) => ajax(`${BASE_URL}factory/system/studio/config/list?type=${type}`);
// 根据类型新增 客户信息  区域  价格
export const reqAddClientInfo = (type, name) => ajax(`${BASE_URL}factory/system/studio/config/save`, { type, name }, 'POST');
// 编辑客户类型
export const reqUpdateClitentInfo = (id, type, name) => ajax(`${BASE_URL}factory/system/studio/config/save`, { id, type, name }, 'POST');
// 删除客户类型
export const reqDelClient = (id) => ajax(`${BASE_URL}factory/system/studio/config/delete/${id}`, {}, 'POST');
// 获取产品属性列表
export const reqGetProductPropList = (id) => ajax(`${BASE_URL}factory/product/attribute/list/${id}`);
// 新增产品属性
export const reqAddProductProp = (name, inputType, selectValues) => ajax(`${BASE_URL}factory/product/attribute/add`, { name, inputType, selectValues }, 'POST');
// 编辑产品属性
export const reqUpdateProductProp = (id, name, inputType, selectValues) => ajax(`${BASE_URL}factory/product/attribute/edit`, { id, name, inputType, selectValues }, 'POST');
// 删除产品属性
export const reqDelProductProp = (id) => ajax(`${BASE_URL}factory/product/attribute/delete/${id}`, {}, 'POST');
// 获取产品尺寸列表
export const reqProductMeasureList = () => ajax(`${BASE_URL}factory/system/dimension/list`);
// 新增产品尺寸
export const reqAddProductMeasure = (name) => ajax(`${BASE_URL}factory/system/dimension/save`, { name }, 'POST');
// 编辑产品尺寸
export const reqEditProductMeasure = (id, name) => ajax(`${BASE_URL}factory/system/dimension/save`, { id, name }, 'POST');
// 删除产品尺寸
export const reqDelProductMwasure = (id) => ajax(`${BASE_URL}factory/system/dimension/delete/${id}`, {}, 'POST');
// 获取库号列表
export const reqGetSetEntrepotNum = params => ajax(`${BASE_URL}factory/system/storehouse/no/list`, params);
// 新增产品库号
export const reqAddSetEntrepotNum = name => ajax(`${BASE_URL}factory/system/storehouse/no/saveList`, name, 'POST');
// 编辑库号
export const reqEditSetEntrepotNum = (id, name, productLabelId) => ajax(`${BASE_URL}factory/system/storehouse/no/save`, { id, name , productLabelId }, 'POST');
// 删除库号
export const reqDelSetEntrepotNum = (id) => ajax(`${BASE_URL}factory/system/storehouse/no/delete/${id}`, {}, 'POST');
// 获取一级 二级设备列表
export const reqGetDeviceList = params => ajax(`${BASE_URL}factory/system/device/list`, params);
// 新增设备 一二级
export const reqAddDevice = params => ajax(`${BASE_URL}factory/system/device/save`, params, 'POST');
// 删除设备
export const reqDelDevice = id => ajax(`${BASE_URL}factory/system/device/delete/${id}`, {}, 'POST');
// 地址新增
export const reqAddressSave = (name, telephone, province, city, region, address, isdefault, provinceCn, cityCn, regionCn) => ajax(`${BASE_URL}factory/address/saveAddress`, { name, telephone, province, city, region, address, isdefault, provinceCn, cityCn, regionCn }, 'POST');
// 地址更新
export const reqAddressEdit = (id, name, telephone, province, city, region, address, isdefault, provinceCn, cityCn, regionCn) => ajax(`${BASE_URL}factory/address/updateAddress`, { id, name, telephone, province, city, region, address, isdefault, provinceCn, cityCn, regionCn }, 'POST');
// 地址删除
export const reqAddressDel = ids => ajax(`${BASE_URL}factory/address/deleteAddress`, { ids }, 'POST');
// /**客户管理*/
// 客户列表
export const reqClientList = params => ajax(`${BASE_URL}factory/studio/findStudioByPage`, params, 'POST');
// 根据关键字搜索客户
export const reqSeachClientByKey2 =params=> ajax(`${BASE_URL}factory/studio/findStudioByKey`, params, 'POST');
export const reqSeachClientByKey = (keys, virtualFlag, source) => ajax(`${BASE_URL}factory/studio/findStudioByKey`, { keys: keys, virtualFlag: virtualFlag, source:1 }, 'POST');
export const reqSeachClientByKey4 = (keys, virtualFlag, source) => ajax(`${BASE_URL}factory/studio/findStudioByKey`, { keys: keys, virtualFlag: virtualFlag, source: 4 }, 'POST');
// 新增客户
export const reqAddClient = (scales, account, address, studioType, priceType, businessArea, factoryUserId, advancePayment,
   drawBalance,bossName, bossPhone, province, city, region, logo, name, password, qq, receiver, receiverPhone, uploador, uploadorPhone,
    deptId, street,deliveryIsFree, provinceCn, cityCn, regionCn, virtualFlag,visibility,provinceId,cityId) =>
  ajax(`${BASE_URL}factory/studio/addStudio`, { scales, account, address, studioType, priceType, businessArea, factoryUserId, advancePayment,
    drawBalance, bossName, bossPhone, province, city, region, logo, name, password, qq, receiver, receiverPhone, uploador, uploadorPhone,
     deptId, street, deliveryIsFree, provinceCn, cityCn, regionCn, virtualFlag,visibility,provinceId,cityId }, 'POST');
export const newreqEditClient = (paarams) =>
  ajax(`${BASE_URL}factory/studio/updateStudio`, paarams, 'POST')
     // 编辑客户
export const reqEditClient = (scales, id, account, address, studioType, priceType, businessArea, factoryUserId, advancePayment,
   drawBalance, bossName, bossPhone, province, city, region, logo, name, password, qq, receiver, receiverPhone, uploador,
    uploadorPhone, deptId, street, deliveryIsFree, provinceCn, cityCn, regionCn,virtualFlag,userId,visibility,provinceId,cityId,activePool) =>
  ajax(`${BASE_URL}factory/studio/updateStudio`, { scales, id, account, address, studioType, priceType, businessArea, factoryUserId,
    advancePayment, drawBalance, bossName, bossPhone, province, city, region, logo, name, password, qq, receiver, receiverPhone,
    uploador, uploadorPhone, deptId, street, deliveryIsFree, provinceCn, cityCn, regionCn,virtualFlag,userId,visibility,provinceId,cityId,activePool}, 'POST')

export const reqEditClients = params => ajax(`${BASE_URL}factory/studio/updateStudio`,params,'POST')

//同步客户价格
export const reqCopyPrice = (originalStudioId,targetStudioIdList) => ajax(`${BASE_URL}factory/product/studio/price/copy`,{originalStudioId,targetStudioIdList},'POST')
  //运费券列表
export const freightList = params => ajax(`${BASE_URL}factory/coupon/findeCouponPage`, params, 'POST')

// 查看客户详情
export const reqGetClientDetail = (studioId) => ajax(`${BASE_URL}factory/studio/findStudioDetail/${studioId}`, {});
// 客户详情中的订单列表
export const reqPayOrderList = (studioId, pageNumber, pageSize, keys, endTime, startTime) => ajax(`${BASE_URL}factory/orderPay/findOrderPayPage`, { studioId, pageNumber, pageSize, keys, endTime, startTime }, 'POST');
// 客户充值
export const reqRechargeAdd = params => ajax(`${BASE_URL}factory/studio/doStudioCharge`, params, 'POST');
// 账户扣款
export const reqRechargeMinute = params => ajax(`${BASE_URL}factory/studio/doStudioPayment`, params, 'POST');
// 获取客户授权产品列表
export const reqGetProductList = params => ajax(`${BASE_URL}factory/studio/findStudioProPage`, params, 'POST');
// 获取客户未授权的产品链表
export const reqGetNoProductList = params => ajax(`${BASE_URL}factory/studio/findUnselectedStudioProPage`, params, 'POST');
// 一键关联产品
export const reqRelatedRroductAll = params => ajax(`${BASE_URL}factory/studio/addStudioPro`, params, 'POST');
// 客户详情中 顾客列表
export const reqClientnextClient = (pageNumber, pageSize, studioId) => ajax(`${BASE_URL}factory/studioCustomer/findStudioCustomerPage`, { pageNumber, pageSize, studioId }, 'POST');
// 查看申请注册用户
// export const reqGetRegisterList = (pageNumber, pageSize) => ajax(`${BASE_URL}factory/studio/findApplyStudioPage`,{pageNumber, pageSize}, 'POST')
// 客户审核
export const reqClientAudit = (studioId, checkStatus) => ajax(`${BASE_URL}factory/studio/checkStudio`, { studioId, checkStatus }, 'POST');
// 删除顾客 其实是禁用
export const reqDelClientByStatus = (id) => ajax(`${BASE_URL}factory/studio/updateStudio`, { id, status: 2, delFlag: 2 }, 'POST');
// 产品一键授权或者取消授权
export const reqProductIsAuth = (skuId, type) => ajax(`${BASE_URL}factory/studio/addProAuth`, { skuId, type }, 'POST');
// 单个产品取消对单个用户的授权
export const reqProductIsAuthSimple = (skuId, studioId, type) => ajax(`${BASE_URL}factory/studio/addProAuth`, { skuId, studioId, type }, 'POST');
// 根据SKUid 查询客户分页信息
export const reqGetClientBySkuId = (pageNumber, pageSize, skuId) => ajax(`${BASE_URL}factory/studio/selectStudioBySkuIdPage`, { pageNumber, pageSize, skuId }, 'POST');
// 查看用户账户详情
export const reqGetClientAmountList = params => ajax(`${BASE_URL}factory/studio/findStudioAccountDetail`, params, 'POST');
// 删除客户 启用禁用客户
export const reqDelDisableClient = params => ajax(`${BASE_URL}factory/studio/updateStudio`, params, 'POST');
// 获取卡券类别
export const reqGetCardType = studioId => ajax(`${BASE_URL}factory/studio/findStudioCouponType`, { studioId }, 'POST');
// 修改客户产品价格
export const reqUpdateProduct = (studioId, skuId, price,isShare) => ajax(`${BASE_URL}factory/studio/addStudioPro`, {studioId, skuId, price,isShare}, 'POST')
//获取运费模板列表
export const reqGetlist = params => ajax(`${BASE_URL}factory/system/freight/template/list`,params)
//仓库管理

//耗材预警
export const stockWarning = params => ajax(`${BASE_URL}factory/inventory/stock/warning`, params)

//查看释放规则
export const getSetStudio = params => ajax(`${BASE_URL}factory/factorySetup/getSetStudio`, params)
//店铺释放设置
export const setUpStudio = params => ajax(`${BASE_URL}factory/factorySetup/setUpStudio`, params,"POST")
//投诉列表
export const getComplaintList = params => ajax(`${BASE_URL}factory/complaint/getComplaintList`, params)
//处理投诉
export const complainHandle = params => ajax(`${BASE_URL}factory/complaint/handle`, params,"POST")
//查询客户池
export const getStudioPool = params => ajax(`${BASE_URL}factory/complaint/getStudioPool`, params)
//指定客户经理
export const appointUser = params => ajax(`${BASE_URL}factory/complaint/appointUser`, params,"POST")
//抢占客户
export const grabCustomer = params => ajax(`${BASE_URL}factory/complaint/userSeize`, params,"POST")



//生产绩效一级分类列表
export const monitorLists = params => ajax(`${BASE_URL}/factory/monitor/monitorList`, params,"POST")

//生产绩效列表
export const monitorList = params => ajax(`${BASE_URL}/factory/monitor/index`, params,"POST")

//新增部门
export const addMonitorDept = params => ajax(`${BASE_URL}/factory/monitor/addMonitorDept`, params,"POST")

//修改时间
export const updateMonitorDept = params => ajax(`${BASE_URL}/factory/monitor/updateMonitorDept`, params,"POST")

// //导出
// export const exportMonitorList = params => ajax(`${BASE_URL}/factory/monitor/exportMonitorList`, params,"POST")

export const exportMonitorList = params => reqExpost('POST',`${BASE_URL}factory/monitor/exportMonitorList`, params);

//
export const delMonitorDept = params => ajax(`${BASE_URL}factory/monitor/delMonitorDept`, params,"POST")



//分类管理
//获取印刷方式列表(不传参)
export const reqCatagoryList = () => ajax(`${BASE_URL}factory/inventory/category/list`,{})
//获取印刷方式二级列表(传参)
export const reqCatagoryList2 = (parentId) => ajax(`${BASE_URL}factory/inventory/category/list`,{parentId})
//删除
export const reqCatagoryDelete = (id) => ajax(`${BASE_URL}factory/inventory/category/delete/${id}`,{},'POST')
// 新增材质分类菜单一级
export const CatagoryListByOne = (name) => ajax(`${BASE_URL}factory/inventory/category/save`,{name,sort: new Date().getTime()},'POST')
//新增二级
export const CatagoryListByTwo = (parentId,name) => ajax(`${BASE_URL}factory/inventory/category/save`,{parentId,name,sort: new Date().getTime()},'POST')
//编辑
export const CatagoryListByEdit = (id,name) => ajax(`${BASE_URL}factory/inventory/category/save`, {id,name},'POST')
//获取耗材库存列表
export const stockList = params => ajax(`${BASE_URL}factory/inventory/stock/list`,params)
//获取入库明细
export const stockInList = params => ajax(`${BASE_URL}factory/inventory/stock/in/list`,params)
//获取出库明细
export const stockOutList = params => ajax(`${BASE_URL}factory/inventory/stock/out/list`,params)
//成品库列表
export const reserveGoods = params => ajax(`${BASE_URL}factory/product/goods/stock/list`,params)
//储备申请列表
export const goodsInList = params => ajax(`${BASE_URL}factory/product/goods/stock/in/list`,params)
//添加储备申请
export const addGoodsIn = params => ajax(`${BASE_URL}factory/product/goods/stock/in`,params,'POST')
//删除申请记录
export const deleteGoodsIn = id => ajax(`${BASE_URL}factory/product/goods/stock/in/delete/${id}`,{},'POST')
//备货订单配货
export const addAllocationOrder = params => ajax(`${BASE_URL}factory/order/addAllocationOrder`,params,'POST')



//新增入库
export const addStockIn = params => ajax(`${BASE_URL}factory/inventory/stock/in`,params,'POST')
//新增出库
export const addStockOut = params => ajax(`${BASE_URL}factory/inventory/stock/out`,params,'POST')
//获取待配货列表
export const distributionList = params => ajax(`${BASE_URL}factory/inventory/production/distribution/list`,params)
//获取耗材明细
export const distributionDetail = id => ajax(`${BASE_URL}factory/inventory/production/distribution/index/${id}`)
//手动配货
export const pickingPro = params => ajax(`${BASE_URL}factory/inventory/production/distribution`,params,'POST')



//供货商
//获取列表
export const reqSupplierList = params => ajax(`${BASE_URL}factory/inventory/supplier/list`,params)
//搜索
export const reqSupplierSearch = (search,current,size) => ajax(`${BASE_URL}factory/inventory/supplier/list`,{search,current,size})
//新增
export const reqSupplierAdd = (name,username,telephone,areaId,address) => ajax(`${BASE_URL}factory/inventory/supplier/save`,{name,username,telephone,areaId,address},'POST')
//编辑
export const reqSupplierEdit = (id,name,username,telephone,areaId,address) => ajax(`${BASE_URL}factory/inventory/supplier/save`,{id,name,username,telephone,areaId,address},'POST')
//删除
export const reqSupplierDel = (id) => ajax(`${BASE_URL}factory/inventory/supplier/delete/${id}`,{},'POST')


// 产品管理
// 产品分类
// 产品订单归类标签设置
// 新增归类标签
export const productManageAddSortTag = (name) => ajax(`${BASE_URL}factory/product/label/add`, { name }, 'POST');
// 获取归类标签列表
export const productManageGetlist = (id) => ajax(`${BASE_URL}factory/product/label/list/${id}`,{})
//编辑
export const productManageEdit = (name, id) => ajax(`${BASE_URL}factory/product/label/edit`,{name,id},'POST')
//启用或禁用
export const productManageStatus = (id,status) => ajax(`${BASE_URL}factory/product/label/status/${id}/${status}`,{},'POST')
//删除
export const productManagedel = (id) => ajax(`${BASE_URL}factory/product/label/delete/${id}`,{},'POST')

//产品分类设置
//获取产品列表
export const productSortGetlist = (parentId) => ajax(`${BASE_URL}factory/product/category/list`,{parentId})
//启用或禁用
export const productSortStatus = (id,status) => ajax(`${BASE_URL}factory/product/category/status/${id}/${status}`,{},'POST')
//排序
export const productSortOrder = (firstId,secondId) => ajax(`${BASE_URL}factory/product/category/sort/${firstId}/${secondId}`,{},'POST')
//获取二级分类未关联属性
export const productSortTexture = (categoryId) => ajax(`${BASE_URL}factory/product/category/attribute/list/${categoryId}`,{},)
//添加二级菜单
export const productSortAdd = (name,parentId,image,attributes) => ajax(`${BASE_URL}factory/product/category/add`,{name,parentId,image,attributes, sort: new Date().getTime()},'POST')
//添加一级菜单
export const productSortAddOne = (name,childrenType) => ajax(`${BASE_URL}factory/product/category/add`,{name,childrenType, sort: new Date().getTime()},'POST')
//删除
export const productSortDel = (id) => ajax(`${BASE_URL}factory/product/category/delete/${id}`,{},'POST')
//编辑
export const productSortEdit = (id,name,image,attributes) => ajax(`${BASE_URL}factory/product/category/edit`,{id,name,image,attributes},'POST')
//获取详情
export const productSortDetail = (id) => ajax(`${BASE_URL}factory/product/category/index/${id}`,{})

//获取某个分类下的SPU
export const cateSpuList = (categoryLevel,categoryId) => ajax(`${BASE_URL}factory/product/category/spu/list/`,{categoryLevel,categoryId})

//批量调整SPU分类信息
export const setSpuCate = (categoryPid,categoryId,spuIdList) => ajax(`${BASE_URL}factory/product/category/spu/reclassification`,{categoryPid,categoryId,spuIdList},'POST')

//产品库
//获取所有产品列表
export const productSkuList = params => ajax(`${BASE_URL}factory/product/sku/list`,params)
// export const productSkuList = (name,categoryPid,categoryId,labelId,deliveryIsFree,isOpen,isRecommend,beginAt,endAt,pageNuber,pageSize,) => ajax(`${BASE_URL}factory/product/sku/list`,{name,categoryPid,categoryId,labelId,deliveryIsFree,isOpen,isRecommend,beginAt,endAt,pageNuber,pageSize,})
// 获取统计信息
export const productSkuInfo = () => ajax(`${BASE_URL}factory/product/sku/statistics`, {});
// 获取一级、二级分类
export const productSkuCategoryList = (parentId) => ajax(`${BASE_URL}factory/product/category/list`, { parentId });
// 获取归类标签
export const productSkuCategorylabelList = (id) => ajax(`${BASE_URL}factory/product/label/list/${id}`, {});
// 删除
export const productSkuCategoryDel = (id) => ajax(`${BASE_URL}factory/product/sku/delete/${id}`, {}, 'POST');
// 产品上下架/审核
export const productSkuCategoryStatus = (id, flag, reason) => ajax(`${BASE_URL}factory/product/sku/status`, { id, flag, reason }, 'POST');
// 编辑单品
export const productSkuCategoryItem = (id, flag, reason) => ajax(`${BASE_URL}factory/product/spu/update`, { id, flag, reason }, 'POST');
// 编辑sku
export const productSkuEdit = params => ajax(`${BASE_URL}factory/product/sku/edit`, params, 'POST');

// 仓库耗材分类
export const costClassList = (parentId) => ajax(`${BASE_URL}factory/inventory/classification/list`, { parentId });

// 仓库耗材信息
export const costInfo = (level, id) => ajax(`${BASE_URL}factory/inventory/body/list`, { level, id });

// 产品管理 上下架流程 单品查询
export const productSkuStatus = params => ajax(`${BASE_URL}factory/product/sku/related/suit`, params);
// 产品管理 上下架流程 套装查询
export const productSkuStatusT = (id) => ajax(`${BASE_URL}factory/product/suit/related/sku/${id}`, {});

// 上架单品
// 添加spu
export const productSpuAdd = params => ajax(`${BASE_URL}factory/product/spu/add`, params, 'POST');
// 获取仓库耗材
export const productSpuInventoryList = () => ajax(`${BASE_URL}factory/product/inventory/list`, {});
// 装订方式
export const productSpuBindingList = () => ajax(`${BASE_URL}factory/system/binding/list`, {});
// 生产工序列表
export const productSpuProcedureList = (id, flag) => ajax(`${BASE_URL}factory/system/binding/list/procedure`, { id, flag });
// 获取尺寸
export const productSkuDimensionList = () => ajax(`${BASE_URL}factory/system/dimension/list`, {});
// 新增客片sku
export const productSkuAdd = params => ajax(`${BASE_URL}factory/product/sku/add`, params, 'POST');
// 编辑spu
export const productSpuEdit = params => ajax(`${BASE_URL}factory/product/spu/edit`, params, 'POST');

// 获取银行账户信息
export const productbankAccount = params => ajax(`${BASE_URL}factory/bankAccount/getList`, params, 'POST');

// 上架套装
export const productSuitAdd = params => ajax(`${BASE_URL}factory/product/suit/add`, params, 'POST');
// 获取产品信息
export const productSuitGetInfo = (id) => ajax(`${BASE_URL}factory/product/sku/index/${id}`, {});
// 编辑套装
export const productSuitEdit = params => ajax(`${BASE_URL}factory/product/suit/edit`, params, 'POST');

/*手动下单模块 */
// 任务列表
export const reqGetTaskList = params => ajax(`${BASE_URL}factory/order/task/findTaskByPage`, params, 'POST');
// 新建传片
// export const reqAddCustomer = params => ajax(`${BASE_URL}factory/order/task/addCustomer`, params, 'POST')
// 获取sku列表
export const reqGetSingleProductList = params => ajax(`${BASE_URL}factory/product/sku/category`, params);
// 获取sku详情
export const reqGetSkuDetail = (id, studioId,isShare) => ajax(`${BASE_URL}factory/product/sku/category/${id}/${studioId}${isShare?'?isShare='+isShare:''}`);
// 查看任务详情
export const reqGetTaskDetail = (cartId) => ajax(`${BASE_URL}factory/order/task/findTaskById/${cartId}`, {}, 'POST');
// 新建传片  点击保存
export const reqSaveClick = params => ajax(`${BASE_URL}factory/order/task/addCustomer`, params, 'POST');
// 订单提交
export const reqOrderCommit = (params) => ajax(`${BASE_URL}factory/order/addOrder`, params, 'POST');
// 订单支付
export const reqOrderPay = params => ajax(`${BASE_URL}factory/orderPay/addOrderPay`, params, 'POST');
// 修改任务
export const reqUpdateTask = params => ajax(`${BASE_URL}factory/order/task/updateCartItemDetail`, params, 'POST');
/* 订单管理*/
//  获取订单列表
export const reqGetOrderList = params => ajax(`${BASE_URL}factory/order/findOrderPage`, params, 'POST');

// 新增或编辑运费模板
export const editTemplate = params => ajax(`${BASE_URL}factory/system/freight/template/save`, params, 'POST');
// 物流公司
export const logisticsCompany = params => ajax(`${BASE_URL}factory/system/logistics/company/list`, params);
// 启用或禁用运费模板
export const reqTemplateStatus = (id, status) => ajax(`${BASE_URL}factory/system/freight/template/status/${id}/${status}`, {}, 'POST');
// 区域管理
export const reqGetArea = (id) => ajax(`${BASE_URL}factory/system/area/list/${id}`);

// 新增或修改物流公司
export const reqeditLogistics = params => ajax(`${BASE_URL}factory/system/logistics/company/save`, params, 'POST');
// 删除物流公司
export const reqeDeleteLogistics = id => ajax(`${BASE_URL}factory/system/logistics/company/delete/${id}`, {}, 'POST');
// 删除运费模板
export const reqeDeletetep = id => ajax(`${BASE_URL}factory/system/freight/template/delete/${id}`, {}, 'POST');
// 启动或禁用物流公司
export const reqLogisticsStatus = (id, status) => ajax(`${BASE_URL}factory/system/logistics/company/status/${id}/${status}`, {}, 'POST');
// 获取运费比较结果
export const reqeGetDiff = params => ajax(`${BASE_URL}factory/system/freight/template/diff`, params);
// 获取省市两级区域信息
export const reqeGetProvinces = params => ajax(`${BASE_URL}factory/system/area/list/province/city`, params);

// 权限管理
export const reqgetDeptList = params => ajax(`${BASE_URL}factory/dept/getDeptList`, params , 'POST');
// 查看成员分页信息
export const reqfindFactoryUserPage = params => ajax(`${BASE_URL}/factory/user/findFactoryUserPage`, params,'POST');

// 调色页面调色开工
export const recolorGoWork = params => ajax(`${BASE_URL}factory/tspb/loadImgList`, params);
// 开始拼版
export const startMakeup = params => ajax(`${BASE_URL}factory/tspb/startImposition`, params);
// 开始拼版
export const finishMakeup = params => ajax(`${BASE_URL}factory/tspb/finishImposition`, params, 'POST');

// 启动或禁用
export const reqUserStatus = params => ajax(`${BASE_URL}factory/user/update`, params, 'POST');
// 新增成员
export const reqAddMember = params => ajax(`${BASE_URL}factory/user/save`, params, 'POST');
// 删除员工
export const reqeDeleteUser = id => ajax(`${BASE_URL}factory/user/deleteUser/${id}`, {}, 'POST');
// 新增部门
export const reqDeptSave = (name) => ajax(`${BASE_URL}factory/dept/save`, { name }, 'POST');
// 获取全部部门
export const reqGetAllDept = () => ajax(`${BASE_URL}factory/dept/getDeptList`, {}, 'POST');
// 获取返工列表
export const GetProductRework = params => ajax(`${BASE_URL}factory/process/reworkList`, params);
// 设置返工
export const goProductRework = params => ajax(`${BASE_URL}factory/process/saveRework`, params, 'POST');
// 返工登记申请数据
export const getDetailInfoByRework = params => ajax(`${BASE_URL}factory/process/getDetailInfoByRework`, params, 'POST');
// 返工审核
export const reworkVerification = params => ajax(`${BASE_URL}factory/process/reworkVerification`, params, 'POST');
// 根据员工码查询员工信息
export const userindex = no => ajax(`${BASE_URL}factory/user/index/${no}`);
// 返工完成
export const updateStatus = params => ajax(`${BASE_URL}factory/process/updateStatus`, params, 'POST');
// 增加区域信息
export const areaAdd = params => ajax(`${BASE_URL}factory/system/area/add`, params, 'POST');

export const selectReworkCategory=(materialCategory)=>ajax(`${BASE_URL}factory/process/selectReworkCategory`,{materialCategory});

// 获取所有设备
export const getdev = params => ajax(`${BASE_URL}factory/system/device/list`,params);

// 成员管理  查看部门树
export const getPartTree = () => ajax(`${BASE_URL}factory/dept/tree`, {}, 'POST');
// 成员管理  查看部门树
export const getPartUser = params => ajax(`${BASE_URL}factory/user/findFactoryUserPage`, params, 'POST');
// 成员管理 新增部门
export const addPart = params => ajax(`${BASE_URL}factory/dept/save`, params, 'POST');
// 成员管理 新增人员
export const addUser = params => ajax(`${BASE_URL}factory/user/save`, params, 'POST');
// 扫码生产跟踪
export const clockIn = params => ajax(`${BASE_URL}factory/process/clockIn`, params, 'POST');
// 成员管理更新成员
export const updateUser = params => ajax(`${BASE_URL}factory/user/update`, params, 'POST');
// 成员管理删除成员
export const deleteUser = params => ajax(`${BASE_URL}factory/user/deleteUser`, params, 'POST');
// 成员管理编辑部门
export const editPart = params => ajax(`${BASE_URL}factory/dept/update`, params, 'POST');
// 订单发货页面 获取信息
export const getOrderDetail = params => ajax(`${BASE_URL}factory/order/findOrderDetail`, params, 'POST');
// 订单发货页面 获取发货信息
export const getSendGoods = params => ajax(`${BASE_URL}factory/order/commitOrderExpress`, params, 'POST');
// 内部返工  完成
export const finishBackWork = params => ajax(`${BASE_URL}factory/process/updateStatus`, params, 'POST');
//订单监控
export const orderView = params => ajax(`${BASE_URL}factory/orderDetail/findOrderMonitorPage`, params, 'POST');
//导出监控订单
export const reqExportOrder = params => reqExpost('POST',`${BASE_URL}factory/orderDetail/exportOrderMonitor`, params);
//生产单监控
export const reqManufactureOrder = params => ajax(`${BASE_URL}factory/orderDetail/findProductionMonitorPage`, params, 'POST');
//导出生产单监控数据
export const reqExportManufactureOrder = params => reqExpost('POST',`${BASE_URL}factory/orderDetail/exportProductionMonitor`, params);
//本周销售导出
export const reqExportWeekSell = params => reqExpost('POST', `${BASE_URL}factory/order/exportOperatorOrderCountData`, params);
//本周订单导出
export const reqExportWeekOrder = params => reqExpost('POST', `${BASE_URL}factory/order/exportRecentWeekOrderInfo`, params);

// 订单列表  图片明细
export const getImage = id => ajax(`${BASE_URL}factory/orderFile/findOrderFile/${id}`, {}, 'GET');
// 订单列表  删除顾客
export const deleteCartItemDetail = cartItemDetailId => ajax(`${BASE_URL}factory/order/task/deleteCartItemDetail/${cartItemDetailId}`, {}, 'POST');
// 订单列表  删除顾客
export const deleteCartItem = obj => ajax(`${BASE_URL}factory/order/task/deleteCartItem`, obj, 'POST');
// 下单获取编辑信息
export const getOrderInfos = params => ajax(`${BASE_URL}factory/order/task/findTaskById`, params, 'POST');
// 调色回调接口
export const Torecolor = params => ajax(`${BASE_URL}factory/tspb/loadCallback`, params, 'POST');
export const finishImposition = params => ajax(`${BASE_URL}factory/tspb/finishImposition`, params, 'POST');
export const getfinishImposition = id => ajax(`${BASE_URL}factory/tspb/getProductionInfo?Id=${id}`);
export const addCodes = params => ajax(`${BASE_URL}factory/orderFile/findCodePicInfo`, params, 'POST');
export const getZHList = () => ajax(`${BASE_URL}factory/bankAccount/getList`, {}, 'POST');
export const setAccount = params => ajax(`${BASE_URL}factory/bankAccount/saveOrUpdate`, params, 'POST');
export const delAccount = id => ajax(`${BASE_URL}factory/bankAccount/delete/${id}`, {}, 'POST');
// 耗材库管理获取耗材列表
export const getMaterial = id => ajax(`${BASE_URL}factory/inventory/classification/list${id ? '?parentId=':''}`);
// 耗材库新增/编辑耗材分类
export const addMaterial = params => ajax(`${BASE_URL}factory/inventory/classification/save`, params, 'POST');
// 获取耗材库耗材信息
export const getMaterialDetail = (id, level) => ajax(`${BASE_URL}factory/inventory/body/list?id=${id}&level=${level}`);
// 获取单位
export const getUnit = type => ajax(`${BASE_URL}factory/system/measurement/unit/list/${type}`);
// 新增/编辑耗材信息
export const addUnit = params => ajax(`${BASE_URL}factory/inventory/body/save`, params, 'POST');

// 耗材信息
export const delMaterial = id => ajax(`${BASE_URL}factory/inventory/body/delete/${id}`, {}, 'POST');

// 客服售后列表
export const saleList = params => ajax(`${BASE_URL}factory/order/feedBack/findOrderFeedbackPage`, params, 'POST');
// 受理
export const handleAccept = params => ajax(`${BASE_URL}factory/order/feedBack/doAccept`, params, 'POST');
// 返工
export const handleRework = params => ajax(`${BASE_URL}factory/order/feedBack/doRework`, params,
  'POST');
// 售后订单详情
export const orderDetail = (id) => ajax(`${BASE_URL}factory/order/feedBack/findOrderFeedBackDetail/${id}`, {},
  'POST');
//售后评分列表
export const getPraise = params => ajax(`${BASE_URL}factory/order/feedBack/praise/statistic`, params);


//：根据影楼端ID登录影楼端：
export const studioLogon = params => ajax(`${BASE_URL}factory/sales/order/studio/login`, params, 'POST');

//样片传片

export const SamplePics = params => ajax(`${BASE_URL}factory/product/sku/sample/pics`, params, 'POST');

// 获取oss参数
export const ossVal = () => ajax(`${BASE_URL}factory/upload/getUploadParam`, {}, 'POST');
// 新增返工订单
export const addOrder = params => ajax(`${BASE_URL}factory/order/feedBack/addOrderFeedBack`, params, 'POST');
// 订单详情
export const orderInfo = id => ajax(`${BASE_URL}factory/order/feedBack/findOrderDetailById/${id}`,
  {}, 'POST');
// 默认地址
export const getDefaultAddress = params => ajax(`${BASE_URL}factory/address/getAddressList`, params, 'POST');

// 影楼
//获取影楼商标配置
export const studioConfigList = params => ajax(`${BASE_URL}factory/studio/config/list`, params);
//更新影楼商标配置
export const studioConfigEdit = params => ajax(`${BASE_URL}factory/studio/config/edit`, params, 'POST');

// 轮播图列表
export const getbannerList = params => ajax(`${BASE_URL}factory/studioSet/bannerList`, params);
// 新增修改轮播图
export const addbannerAddOrUpdate = params => ajax(`${BASE_URL}factory/studioSet/bannerAddOrUpdate`, params, 'POST');
// 轮播图状态
export const postUpdateStatus = params => ajax(`${BASE_URL}factory/studioSet/updateStatus`, params, 'POST');
// 删除轮播图
export const postBannerDel = params => ajax(`${BASE_URL}factory/studioSet/bannerDel`, params, 'POST');

// 消息列表
export const getNotifyList = params => ajax(`${BASE_URL}factory/studioSet/getNotifyList`, params);
// 新增消息更改消息
export const addOrUpdateNotify = params => ajax(`${BASE_URL}factory/studioSet/addOrUpdateNotify`, params, 'POST');
// 删除消息
export const deleteNotify = params => ajax(`${BASE_URL}factory/studioSet/deleteNotify`, params, 'POST');
//投诉类目列表
export const getCategoryList = params => ajax(`${BASE_URL}factory/studio/complaint/category/list`, params);
//新增投诉列表
export const getCategoryAdd = params => ajax(`${BASE_URL}factory/studio/complaint/category/add`, params, 'POST');
//编辑投诉列表
export const getCategoryEdit = params => ajax(`${BASE_URL}factory/studio/complaint/category/edit`, params, 'POST');
//启用禁用投诉列表
export const getCategoryStatus = params => ajax(`${BASE_URL}factory/studio/complaint/category/status`, params, 'POST');
//投诉类目排序
export const getSort = params => ajax(`${BASE_URL}/factory/studio/complaint/sort`, params, 'POST');
// 视频教程列表
export const findTutorial = params => ajax(`${BASE_URL}factory/studioSet/findTutorial`, params);
// 视频教程删除
export const deleteTutorial = params => ajax(`${BASE_URL}factory/studioSet/deleteTutorial`, params, 'POST');
// 视频教程修改或新增
export const addOrUpdateTutorial = params => ajax(`${BASE_URL}factory/studioSet/addOrUpdateTutorial`, params, 'POST');
// 检验spu名称是否存在
export const spuName = (name) => ajax(`${BASE_URL}factory/product/spu/name`, { name });
export const logining = params => ajax(`${BASE_URL}factory/login`, params, 'POST');

//获取影楼充值设置列表
export const rechargeConfigList = params => ajax(`${BASE_URL}factory/studio/balance/recharge/config/list`, params);
//新增影楼充值设置影楼
export const rechargeConfigAdd = params => ajax(`${BASE_URL}factory/studio/balance/recharge/config/add`, params ,'POST');
//编辑影楼充值设置影楼
export const rechargeConfigEdit  = params => ajax(`${BASE_URL}factory/studio/balance/recharge/config/edit`, params, 'POST');
//删除禁用启用影楼充值设置影楼
export const rechargeConfigStatus = params => ajax(`${BASE_URL}factory/studio/balance/recharge/config/status`, params, 'POST');
//充值设置选择区域范围
export const rechargeLimitSet = params => ajax(`${BASE_URL}factory/studio/balance/recharge/limit/set`, params, 'POST');
//充值设置获取
export const rechargeLimitList = params => ajax(`${BASE_URL}factory/studio/balance/recharge/limit/list`, params);
//取消影楼关联
export const rechargeLimitReset = params => ajax(`${BASE_URL}factory/studio/balance/recharge/limit/reset`, params, 'POST');


//影楼充值送活动列表
export const activityConfigList = params => ajax(`${BASE_URL}/factory/studio/activity/config/list`, params);
//新增
export const activityConfigAdd = params => ajax(`${BASE_URL}/factory/studio/activity/config/add`, params, 'POST');
//编辑
export const activityConfigEdit = params => ajax(`${BASE_URL}/factory/studio/activity/config/edit`, params, 'POST');
//启用禁删除
export const activityConfigStatus = params => ajax(`${BASE_URL}/factory/studio/activity/config/status`, params, 'POST');



//模糊搜索产品
export const cRechargeConfigSku = params => ajax(`${BASE_URL}factory/product/sku/name/index`, params);
//获取产品券列表
export const cRechargeConfigList = params => ajax(`${BASE_URL}factory/studio/coupon/recharge/config/list`, params);
//新增产品券
export const cRechargeConfigAdd = params => ajax(`${BASE_URL}factory/studio/coupon/recharge/config/add`, params, 'POST');
//编辑产品券设置影楼
export const cRechargeConfigEdit = params => ajax(`${BASE_URL}factory/studio/coupon/recharge/config/edit`, params, 'POST');
//删除禁用启用产品券
export const cRechargeConfigStatus = params => ajax(`${BASE_URL}factory/studio/coupon/recharge/config/status`, params, 'POST');
//充值设置选择区域范围
export const cRechargeLimitSet = params => ajax(`${BASE_URL}factory/studio/coupon/recharge/limit/set`, params, 'POST');
//充值设置获取
export const cRechargeLimitList = params => ajax(`${BASE_URL}factory/studio/coupon/recharge/limit/list`, params);
//取消影楼关联
export const cRechargeLimitReset = params => ajax(`${BASE_URL}factory/studio/coupon/recharge/limit/reset`, params, 'POST');

// 版本号管理
// 新增编辑
export const insertOrUpdate = params => ajax(`${BASE_URL}factory/system/version/insertOrUpdate`, params, 'POST');
// 列表
export const findSystemVersionPage = params => ajax(`${BASE_URL}factory/system/version/findSystemVersionPage`, params, 'POST');
// 删除
export const versionListdelete = (id) => ajax(`${BASE_URL}factory/system/version/delete/${id}`, {});

// 新增尺寸分组
export const groupIn = params => ajax(`${BASE_URL}factory/system/dimension/group/in`, params, 'POST');
// 解除分组
export const cancelGroup = params => ajax(`${BASE_URL}factory/system/dimension/group/out`, params, 'POST');


//销售下单
// 添加购物车
export const postaddCart = params => ajax(`${BASE_URL}factory/sales/order/addCart`, params, 'POST');

// 更新消息状态
// export const postnews = params => ajax(`${BASE_URL}/sales/order/updateRead`, params, 'POST');

// 订单列表
export const getfindOrderPage = params => ajax(`${BASE_URL}factory/sales/order/findOrderPage`, params);

//获取订单扣款明细
export const orderPayDetail = params => ajax(`${BASE_URL}factory/order/selectPayDetail`, params,'POST');

//截单
export const doCutOrder = params => ajax(`${BASE_URL}factory/order/doOrderRollback`, params,'POST');


// 保存购物车
export const postaddCustomer = params => ajax(`${BASE_URL}factory/sales/order/addCustomer`, params, 'POST');

// 提交订单
export const postaddOrder = params => ajax(`${BASE_URL}factory/sales/order/addOrder`, params, 'POST');

// 订单选择快递
export const postaddOrderDelivery = params => ajax(`${BASE_URL}factory/sales/order/addOrderDelivery`, params, 'POST');

// 订单支付
export const postaddOrderPay = params => ajax(`${BASE_URL}factory/sales/order/addOrderPay`, params, 'POST');
// 订单状态列表
export const getfindOrderStatusCount = params => ajax(`${BASE_URL}factory/sales/order/findOrderStatusCount`, params);

// 获取suk信息
export const getselectProductSku = params => ajax(`${BASE_URL}factory/sales/order/selectProductSku`, params);

// 购物车列表
export const getFindCartList = params => ajax(`${BASE_URL}factory/sales/order/findCart`, params);

// 删除购物车
export const postdelectCart = params => ajax(`${BASE_URL}factory/sales/order/delCart`, params, 'POST');

// 删除购物车客户
export const postdeleteCartItemDetail = params => ajax(`${BASE_URL}factory/sales/order/deleteCartItemDetail`, params, 'POST');


// 商品详情
export const selectProductDetail = params => ajax(`${BASE_URL}factory/sales/order/selectProductDetail`, params);


// 获取省市
export const getregion = params => ajax(`${BASE_URL}factory/sales/order/list/province/city`, params);

// 根据父级id获取区域
export const getparentId = id => ajax(`${BASE_URL}factory/sales/order/list/${id}`);

//时间超时分组条数
export const overTimeOrder = (conditionHours) => ajax(`${BASE_URL}factory/orderDetail/selectOrderMonitorOutDateCount`,{conditionHours},'POST');


//获取运费券
export const freight = params => ajax(`${BASE_URL}factory/sales/order/coupon/freight`, params);

//仓库下单
export const warehouseOrder = params => ajax(`${BASE_URL}factory/order/inventory/new`, params,'POST');

//获取默认的发货地址
export const deliveryAddress = () => ajax(`${BASE_URL}factory/order/inventory/delivery/address`);

//仓库发货列表
export const warehouseOrderList = params => ajax(`${BASE_URL}factory/order/inventory/list`, params,);

//仓库发货详情
export const warehouseOrderDetail = params => ajax(`${BASE_URL}factory/order/inventory/detail`, params);

//仓库发货
export const warehouseSendGoods = params => ajax(`${BASE_URL}factory/order/inventory/freight`, params,'POST');

//仓库发货获取已发货的打印快递单信息
export const getPrintInfo = params => ajax(`${BASE_URL}factory/order/inventory/freight/print`, params);

//仓库发货获取物流信息
export const getExpressInfo = params => ajax(`${BASE_URL}factory/order/inventory/freight/trace`, params);

export const chartData = params => ajax(`${BASE_URL}factory/order/selectIndexStatistical`,params,'POST');
//清空购物车
export const postclear = params => ajax(`${BASE_URL}factory/sales/order/clear`,params,'POST');


//调整sku列表状态
export const skuStatusHandle = params => ajax(`${BASE_URL}factory/product/sku/handle`,params,'POST');

//更改已授权给客户的产品的是否开放购买属性
export const studioOpen = params => ajax(`${BASE_URL}factory/studio/open`,params,'POST');

//获取某个员工的生产绩效
export const financeMonthDay = params => ajax(`${BASE_URL}factory/finance/financeMonthDay`,params);

//获取某个员工的生产绩效明细
export const finnaceUserList = params => ajax(`${BASE_URL}factory/finance/finnaceUserList`,params);

//获取调色绩效列表
export const colorMoneyList = params => ajax(`${BASE_URL}factory/finance/colorMoney`,params);

//获取调色绩效明细
export const ColorMoneyDetail = params => ajax(`${BASE_URL}/factory/finance/getColorMoneyDetail`,params);


// export const postclear = params => ajaxPost({ url: ``,params})
//获取模板图片
export const template = params => ajax(`${BASE_URL}factory/sales/order/template`,params,'POST');

//获取默认拼版p数
export const getMaxp = () => ajax(`${BASE_URL}factory/getDefaultP`);

//设置默认拼版p数
export const setMaxp = params => ajax(`${BASE_URL}factory/updateDetailP`,params,'POST');

//更新打印状态
export const updatePrintStatus = params => ajax(`${BASE_URL}factory/tspb/updatePrinting`,params,'POST');


//获取财务主页信息
export const financialStatistic = params => ajax(`${BASE_URL}factory/finance/statistic/order`,params);

//获取产品销量分析
export const reqProductsales = params => ajax(`${BASE_URL}factory/system/statistic/sku/count`,params);

//获取单个产品销量趋势
export const reqSkusales = params => ajax(`${BASE_URL}factory/system/statistic/sku/trend`,params);

//收款账户和扣款账户设置
export const setBankAccount = params => ajax(`${BASE_URL}factory/bankAccount/inOut`,params,'POST');


//*******财务二级页面********

//现金流》线上支付列表页
export const statisticOnlineList = params => ajax(`${BASE_URL}factory/finance/statistic/online/recharge/list`,params);

//现金流》线下打款列表页
export const statisticOfflineList = params => ajax(`${BASE_URL}factory/finance/statistic/offline/recharge/list`,params);

//现金流》购买产品券列表页
export const cashBuyCouponList = params => ajax(`${BASE_URL}factory/finance/statistic/buy/sku/coupon/list`,params);

//订单统计》半成品订单列表页
export const orderInventoryList = params => ajax(`${BASE_URL}factory/finance/statistic/order/inventory/list`,params);

//订单统计》样品订单列表页
export const orderSampleList = params => ajax(`${BASE_URL}factory/finance/statistic/order/sample/list`,params);

//订单统计》产品券抵扣列表页
export const orderCouponList = params => ajax(`${BASE_URL}factory/finance/statistic/order/coupon/list`,params);

//订单统计》订单扣款列表页
export const orderMoneyList = params => ajax(`${BASE_URL}factory/finance/statistic/order/money/list`,params);

//营销费用
export const marketingMoneyList = params => ajax(`${BASE_URL}factory/finance/statistic/gift/coupon/list`,params);

//预备库存
export const studioMoneyList = params => ajax(`${BASE_URL}factory/finance/statistic/studio/money/list`,params);



//拼版设置列表
export const makeupSettingList = params => ajax(`${BASE_URL}factory/production/list`,params);

//拼版设置增加项目
export const AddMakeupSetting = params => ajax(`${BASE_URL}factory/production/save`,params,'POST');

//拼版设置编辑项目
export const EditMakeupSetting = params => ajax(`${BASE_URL}factory/production/update`,params,'POST');

//拼版设置删除项目
export const deleteMakeupSetting = params => ajax(`${BASE_URL}factory/production/delete`,params,'POST');

//检测skuName是否存在
export const checkSkuName = params => ajax(`${BASE_URL}factory/product/sku/name/index`,params);

//获取拼版印刷材质等参数
export const makeupParams = params => ajax(`${BASE_URL}factory/process/getParams`,params);




//*************营销管理**********

//新增代理
export const addAgent = params => ajax(`${BASE_URL}factory/agent/saveAgent`,params,'POST');

//编辑或删除代理
export const updateAgent = params => ajax(`${BASE_URL}factory/agent/updateAgent`,params,'POST');

//获取一级代理列表
export const reqOneAgentList = params => ajax(`${BASE_URL}factory/agent/oneAgentList`,params);

//代理人员列表
export const reqAgentList = params => ajax(`${BASE_URL}factory/agent/getMarketList`,params);

//代理人员信息
export const agentStatistics = params => ajax(`${BASE_URL}factory/agent/agentStatistics`,params);

//代理客户列表
export const agentCustomer = params => ajax(`${BASE_URL}factory/agent/agentStudioList`,params);

//代理关联客户
export const addAgentStudio = params => ajax(`${BASE_URL}factory/agent/addAgentStudio`,params,'POST');

//取消关联客户
export const delAgentStudio = params => ajax(`${BASE_URL}factory/agent/delAgentStudio`,params,'POST');

//代理产品列表(已关联)
export const agentSkuList = params => ajax(`${BASE_URL}factory/agent/agentSkuList`,params);

//代理产品列表(未关联)
export const notAgentSkuList = params => ajax(`${BASE_URL}factory/agent/notAgentSkuList`,params);

//添加代理产品
export const addAgentSku = params => ajax(`${BASE_URL}factory/agent/addAgentSku`,params,'POST');

//设置代理产品提成
export const updateAgentSku = params => ajax(`${BASE_URL}factory/agent/updateAgentSku`,params,'POST');

//取消代理产品
export const delAgentSku = params => ajax(`${BASE_URL}factory/agent/delAgentSku`,params,'POST');

//获取二级代理产品本书详情列表
export const getStudioCountList = params => ajax(`${BASE_URL}factory/agent/getStudioCountList`,params,'POST');

//获取部门列表
export const reqGetDept = () => ajax(`${BASE_URL}factory/dept/getYxDeptList`, {}, 'POST');


//******首页-生产绩效

//按部门统计绩效
export const deptPerformance = params => ajax(`${BASE_URL}factory/finance/statistic/production/performance/dept`, params);

//获取某部门下属员工绩效
export const userPerformance = params => ajax(`${BASE_URL}factory/finance/statistic/production/performance/user`, params);

//分工序按天统计某员工绩效
export const userPerformanceDay = params => ajax(`${BASE_URL}factory/finance/statistic/production/performance/user/day`, params);

//按时统计某员工绩效
export const userPerformanceHour = params => ajax(`${BASE_URL}factory/finance/statistic/production/performance/user/hour`, params);

//******首页-库存预警
//耗材库存明细
export const stockWarningStatistic = params => ajax(`${BASE_URL}factory/inventory/stock/warning/statistic`, params);

//******首页-营销业绩

//页面左侧
export const indexLeft = params => ajax(`${BASE_URL}factory/statistics/indexLeft`, params,"POST");

//页面右侧
export const indexRight = params => ajax(`${BASE_URL}factory/statistics/indexRight`, params,"POST");

//充值现金券
export const couponRecharge = params => ajax(`${BASE_URL}factory/studio/cash/coupon/recharge`, params,"POST");

//获取产品现金券列表
export const paramsList = params => ajax(`${BASE_URL}factory/studio/cash/coupon/list`, params);

//扣减产品现金券列表、
export const couponDeduction = params => ajax(`${BASE_URL}factory/studio/cash/coupon/deduction`, params,"POST");

//现金券详情
export const couponIndex = params => ajax(`${BASE_URL}/factory/studio/cash/coupon/index`, params);

//备货订单获取价格
export const getStudioSkuPrice = params => ajax(`${BASE_URL}/factory/order/getStudioSkuPrice`, params);

//获取运费券
export const selectOrderCarriageCoupon = params => ajax(`${BASE_URL}/factory/order/selectOrderCarriageCoupon`, params);

//新增产品库存
export const addGoodsStock = params => ajax(`${BASE_URL}/factory/product/goods/stock/addGoodsStock`, params,"POST");

//修改产品库存数量
export const modifyStock = params => ajax(`${BASE_URL}/factory/product/goods/stock/modifyStock`, params,"POST");

//根据设备id获取相关信息
export const getDeviceById = params => ajax(`${BASE_URL}/factory/system/device/getDeviceById`, params);

//获取发货绩效
export const getDeliverList = params => ajax(`${BASE_URL}/factory/finance/getDeliverList`, params);

//获取发货绩效明细
export const getDeliverDetailList = params => ajax(`${BASE_URL}/factory/finance/getDeliverDetailList`, params);
 

//获取运费模板的小件计费规则
export const templateSmall = params => ajax(`${BASE_URL}/factory/system/freight/template/list/small`, params);

//查询产品生产流程信息
export const getProductionDetail = params => ajax(`${BASE_URL}/factory/orderDetail/getProductionDetail`, params);

//获取员工级别列表
export const selectDictByType = params => ajax(`${BASE_URL}/factory/system/dict/selectDictByType`, params);

//根据spuId获取sku列表
export const getSkuBySpuId = params => ajax(`${BASE_URL}/factory/product/getSkuBySpuId`, params);

//删除spu
export const deleteSpu = params => ajax(`${BASE_URL}/factory/product/delSpu`, params,"POST");

//挂起统计
export const pendingStatis = params => ajax(`${BASE_URL}/factory/monitor/pendingStatis`, params);

//返工传值
export const otherRework = params => ajax(`${BASE_URL}/factory/order/otherRework`, params,"POST");

//售后绩效
export const orderAfterList = params => ajax(`${BASE_URL}/factory/orderAfter/getList`, params);
//
export const scoreSetList = params => ajax(`${BASE_URL}/factory/orderAfter/scoreSetList`, params);

export const muiPrice = params => ajax(`${BASE_URL}/factory/orderAfter/muiPrice`, params,"POST");

//到处售后绩效
export const exportOrderAfterList = params => reqExpost('POST', `${BASE_URL}factory/orderAfter/exportOrderAfterList`, params);
